import styled from '@emotion/styled';

import { authColors } from 'design-system/tokens';

export const RulesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const RulesTitle = styled.strong`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  color: ${authColors.textStrong};
`;
export const RulesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
`;
export const RuleRow = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textBody};

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;
export const RuleOk = styled.span`
  display: inline-flex;
  color: #4ec937;
`;
export const RuleFail = styled.span`
  display: inline-flex;
  color: ${authColors.required};
`;
